import React from 'react'
import Header from '../_layouts/public/Header'
import Footer from '../_layouts/public/Footer'
import bags from './../../assets/img/bags.jpeg';
import WelcomeArea2 from '../_layouts/public/pages/WelcomeArea2';
import { Link } from 'react-router-dom';

const Contact = () => {
    const pg = 'Contact Us';

  return (
    <>
    <Header />
    <WelcomeArea2 pg={pg} />

    <section className="mosh-aboutUs-area py-5">
        <div className="container py-4">
            <div className="row align-items-center">
                <div className="col-12 col-md-6">
                    <div className="mosh-about-us-content">
                        <div className="section-heading mb-4">
                            <h2><span className="green-span">Contact us </span><br />We are here to help</h2>
                        </div>

                        <br />
                        <h5>No. 3, G Close 3rd Avenue, Gowon Estate, <br />
                            Ipaja New layout, Alimosho, <br />
                            Lagos, Nigeria</h5>
                    </div>
                </div>
            </div>

            
            <div className="row mt-5">
                <div className="col-12 col-md-3 text-center">
                    <i className="fa fa-phone fa-2x text-success mb-3"></i>
                    <h5>+234 (0)903-814-8585<br />
                        +234 (0)907-742-2961</h5>
                </div>

                <div className="col-12 col-md-3 text-center">
                    <i className="fa fa-whatsapp fa-2x text-success mb-3"></i>
                    <h5>+234 (0)903-814-8585</h5>
                </div>
                
                <div className="col-12 col-md-3 text-center">
                    <i className="fa fa-envelope fa-2x text-success mb-3"></i>
                    <h5>mipatfarms@gmail.com</h5>
                </div>
                
                <div className="col-12 col-md-3 text-center">
                    <i className="fa fa-facebook fa-2x text-success mb-3"></i>
                    <h5>/mipatfarms</h5>
                </div>
            </div>

            <div className='text-center'>
                <Link to="/products" class="btn mosh-btn mt-4 ">shop our products</Link> 
            </div>

        </div>
    </section> 

    <Footer />
    </>
  )
}
export default Contact;